<adapt-dashboard-element *adaptLoadingUntilFirstEmit="let team of team$"
                         data-test="edit-team-locations"
                         name="Location"
                         [disableClick]="!canEditTeam"
                         (headerClicked)="editLocation(team)">
    <div class="d-flex flex-column">
        <adapt-list-team-locations [team]="team"></adapt-list-team-locations>
        <adapt-team-hierarchy-dashboard-element [team]="team"></adapt-team-hierarchy-dashboard-element>
    </div>
</adapt-dashboard-element>
